import {createContext, useContext} from 'react';
import {v4 as uuidv4} from 'uuid';

let sessionId = '';

if (typeof window !== 'undefined') {
  sessionId = sessionStorage.getItem('sessionId') || uuidv4();
  sessionStorage.setItem('sessionId', sessionId);
}

export const SessionIdContext = createContext(sessionId);

export function useSessionId() {
  return useContext(SessionIdContext);
}
